import { IState } from '../../store';

export const getFavoritesFolderEnabled = (state: IState) => state.featureToggle.isFavoritesFolderEnabled;
